const loginErrors = {
  WRONG_CREDENTIALS: '¡Vaya! El correo y/o contraseña no son válidos.',
  WRONG_CLIENT: '¡Vaya! El correo y/o contraseña no son válidos.',
  TRY_AGAIN: '¡Oops! Parece que algo salío mal. Por favor, vuelve a intentarlo más tarde.'
};

export default loginErrors;
